const interfaceTranslations = {
  selectedCountryAriaLabel: "Valitud riik",
  noCountrySelected: "Ühtegi riiki pole valitud",
  countryListAriaLabel: "Riikide nimekiri",
  searchPlaceholder: "Otsi",
  zeroSearchResults: "Tulemusi ei leitud",
  oneSearchResult: "1 tulemus leitud",
  multipleSearchResults: "${count} tulemust leitud",
  // additional countries (not supported by country-list library)
  ac: "Ascensioni saar",
  xk: "Kosovo"
};
export default interfaceTranslations;